module.exports = __webpack_public_path__ + "static/img/Logo_FoxiMed.7754e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_FoxiMed.png
// module id = 54pb
// module chunks = 7